import type {
  GetBuyerPageOptionsResponse,
  GetBuyerPageOptions,
} from '@/types/api/customer/BuyerPageMeta/index.ts'

import { useApiForCustomer } from '@/composables/useApi'

/**
 * バイヤーページオプションを取得
 */
export const getBuyerPageOptions: GetBuyerPageOptions = () =>
  useApiForCustomer<GetBuyerPageOptionsResponse>(
    '/rest/buyer/page-options',
    {
      method: 'GET',
    },
  )
